import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { LinkHighlighter } from '@anyx/feature-crm/shared';


interface TextPreviewProps {
  text?: string;
}

export const TextPreview = ({ text }: TextPreviewProps) => {
  const { t } = useTranslation('crm');

  return (
    <div
      className={classNames(
        'rounded-chat-bubble p-3 text-xs break-words whitespace-pre-line drop-shadow',
        {
          'text-gray-9 bg-white': text,
          'text-gray-5 bg-gray-1': !text,
        }
      )}
    >
      <LinkHighlighter
        text={text}
        placeholder={t('crm.anychatForm.preview.plainText.placeholder')}
      />
    </div>
  );
};
